import { css } from 'lit';

export default css`
  :host {
    --sl-icon-fill-accent: var(--sl-color-palette-accent-300);
    --sl-icon-fill-default: currentcolor;
    --sl-icon-size: var(--sl-size-200);

    aspect-ratio: 1/1;
    display: inline-grid;
    inline-size: max(1cap, var(--sl-icon-size));
    outline: none;
    place-content: center;
    translate: 0;
  }

  :host([size='2xs']) {
    --sl-icon-size: var(--sl-size-125);
  }

  :host([size='xs']) {
    --sl-icon-size: var(--sl-size-150);
  }

  :host([size='sm']) {
    --sl-icon-size: var(--sl-size-175);
  }

  :host([size='md']) {
    --sl-icon-size: var(--sl-size-200);
  }

  :host([size='lg']) {
    --sl-icon-size: var(--sl-size-250);
  }

  :host([size='xl']) {
    --sl-icon-size: var(--sl-size-300);
  }

  :host([size='2xl']) {
    --sl-icon-size: var(--sl-size-400);
  }

  :host([size='3xl']) {
    --sl-icon-size: var(--sl-size-600);
  }

  :host([size='4xl']) {
    --sl-icon-size: var(--sl-size-800);
  }

  svg {
    aspect-ratio: 1/1;
    inline-size: 100%;
  }
`;
